export default __webpack_public_path__ + "static/media/BIFI-MATIC.87a15020.png";